export const { phone1, phone2, email, website, address } = {
  phone1: "+91 99409 05580",
  email: " sales.majesticoffice@gmail.com",
  website: "www.majestic_Office Inc.in",
  address:
    "No 81, Balepet Cross, Hospital Road, Balepet, Gandhinagar, Balepete, Chickpet, Bengaluru, Karnataka 560053",
};
